module.exports = __webpack_public_path__ + "img/Mia.68a8c506.png";